import { Page } from "./page";
import { Book } from "./book";

export class BookOverview extends Page 
{
    items : Book[];
}
